export default __webpack_public_path__ + "static/media/square.5a1c55ac.png";